export default __webpack_public_path__ + "static/media/bulb.9fcfbd90.svg";